/** Shared JSON profile defaults. Callers receive their own settings object. */
export const defaultItemSettings = {
  defaultImageUrl: '/assets/images/common/sample.jpg',
  defaultImageWidth: 260,
  defaultImageHeight: 331,
  socialIconBasePath: '/assets/images/common/',
};
export const socialLinksData = [
  { name: 'twitter', label: 'X', icon: 'icon_twitter.svg' },
  { name: 'instagram', icon: 'icon_instagram.png' },
  { name: 'facebook', icon: 'icon_facebook.svg' },
  { name: 'youtube', icon: 'icon_youtube_bk.svg' },
];
